enum BeltType {
	Year = 0,
	Quarter = 1,
	Month = 2,
}

export default BeltType;